function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
var SvgLandingConditions5 = function SvgLandingConditions5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 262 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    y: -4,
    width: 32,
    height: 233,
    fill: "url(#paint0_linear_18186_115884)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: -4,
    width: 33,
    height: 233,
    fill: "url(#paint1_linear_18186_115884)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: -4,
    width: 32,
    height: 233,
    fill: "url(#paint2_linear_18186_115884)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: -4,
    width: 33,
    height: 233,
    fill: "url(#paint3_linear_18186_115884)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: -4,
    width: 32,
    height: 233,
    fill: "url(#paint4_linear_18186_115884)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: -4,
    width: 33,
    height: 233,
    fill: "url(#paint5_linear_18186_115884)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195,
    y: -4,
    width: 32,
    height: 233,
    fill: "url(#paint6_linear_18186_115884)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227,
    y: -4,
    width: 32,
    height: 233,
    fill: "url(#paint7_linear_18186_115884)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259,
    y: -4,
    width: 33,
    height: 233,
    fill: "url(#paint8_linear_18186_115884)"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18186_115884",
    x1: -8.72556e-7,
    y1: 82.2548,
    x2: 32,
    y2: 82.2548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18186_115884",
    x1: 32,
    y1: 82.2548,
    x2: 65,
    y2: 82.2548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_18186_115884",
    x1: 65,
    y1: 82.2548,
    x2: 97,
    y2: 82.2548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_18186_115884",
    x1: 97,
    y1: 82.2548,
    x2: 130,
    y2: 82.2548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_18186_115884",
    x1: 130,
    y1: 82.2548,
    x2: 162,
    y2: 82.2548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_18186_115884",
    x1: 162,
    y1: 82.2548,
    x2: 195,
    y2: 82.2548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_18186_115884",
    x1: 195,
    y1: 82.2548,
    x2: 227,
    y2: 82.2548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_18186_115884",
    x1: 227,
    y1: 82.2548,
    x2: 259,
    y2: 82.2548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_18186_115884",
    x1: 259,
    y1: 82.2548,
    x2: 292,
    y2: 82.2548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737373"
  }))));
};
export default SvgLandingConditions5;